import { notification } from 'antd'
import { definedErrorCodes, handleErrors } from 'helpers'
import axios from './axiosInstance'
import constants from '../constants'
import { isAuthenticated } from '../utils/authSession'

const URL = `${constants.customerDomain}plans`

export default async function getPlans() {
  try {
    if (isAuthenticated()) {
      const res = await axios.get(URL)
      return res.data.data
    }
  } catch (error) {
    const errorCode = error.response?.data?.error?.code ?? ''
    const { message, description } = handleErrors(definedErrorCodes(errorCode) ? errorCode : '')
    notification.error({ message, description })
    return true // Indicates request was sent but failed due to some error
  }
  return false // Not authenticated — the call was never made
}
